import React, { useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay } from "swiper/modules";

// Import Swiper styles (core, navigation optional)
import 'swiper/css';
import 'swiper/css/navigation'; // If you want navigation arrows
// import 'swiper/css/pagination'; // If you want pagination dots

// Import Swiper core and required modules
import { Navigation /*, Pagination */ } from 'swiper/modules';

// Import the CSS module for styling
import styles from './css/TransformationSliderDesktop.module.css';


import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styled from 'styled-components';

import Lottie from "lottie-react";
import bwsconfetti from "../lottiedata/bwsconfetti.json";

const Confetti= styled.div`
  width:90%;
  position: absolute;
    top: 20%;
    z-index: 100;
   
        height: 100%;
    scale: 2;
`;
// --- Placeholder Data ---
// Replace image URLs with your actual image paths or imports
const transformationData = [
  {
    id: 'today',
    index: 0,
    timelineLabel: 'Today',
    subtitle: 'Getting Started',
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male1.png', // Replace with your image path
    bodyFat: '25%',
    experienceLevel: 'Beginner',
    description: 'Building the foundation – this is where your fitness journey begins!',
  },
  {
    id: 'may',
    index: 1,
    timelineLabel: 'May',
    subtitle: 'Seeing Changes', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male2.png', // Replace with your image path
    bodyFat: '22%', // Example data
    experienceLevel: 'Novice', // Example data
    description: 'Momentum kicks in – your body starts to shift as healthy habits take root.', // Example data
  },
  {
    id: 'july',
    index: 2,
    timelineLabel: 'July',
    subtitle: 'Major Progress', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male3.png', // Replace with your image path
    bodyFat: '18%', // Example data
    experienceLevel: 'Intermediate', // Example data
    description: 'Muscle definition is showing – you’re leaning out and staying consistent.', // Example data
  },
  {
    id: 'sept',
    index: 3,
    timelineLabel: 'Sept',
    subtitle: 'Goal Achieved', // Example subtitle
    imageUrl: 'https://builtwithscience.com/wp-content/uploads/2025/04/image_male4.png', // Replace with your image path
    bodyFat: '15%', // Example data
    experienceLevel: 'Advanced', // Example data
    description: 'Dialled in and athletic – your hard work is now fully visible!', // Example data
  },
];
// --- End Placeholder Data ---


function TransformationSliderDesktop( props ) {



  const [activeIndex, setActiveIndex] = useState(0);
  const sliderscount=props.sliderscount;
  
  let last_index=3;
  if(sliderscount === 3){
    last_index=2;
  }
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
    if (swiper.realIndex === last_index) {
      // Stop autoplay when reaching slide 3
      swiper.autoplay.stop();
      console.log("Autoplay stopped on slide 3");
    }
   // console.log("ActiveIndex:",activeIndex);
  };
  const transformationData =props.transformationData;

  

  return (
    <div className={styles.container}>
    

      {/* Timeline */}
      <div className={styles.timelineContainer}>
        {transformationData.map((item, index) => (
          <React.Fragment key={item.id}>
            <div
              className={`${styles.timelineStep} ${
                index === activeIndex ? styles.activeStep : ''
              } ${index <= activeIndex ? styles.visitedStep : ''} ${ activeIndex  === last_index? styles.finnalStep : ''}`}
            >
              <div className={styles.timelineDot}></div>
              <div className={styles.timelineLabel}>{item.timelineLabel}</div>
              <div className={styles.timelineSubtitle}>{item.labelbodyfat}</div>
            </div>
            {/* Render line connecting dots except for the last one */}
            {index < transformationData.length - 1 && (
             
                <>
                <div
                  className={`${ sliderscount ===3 ? styles.timelineLine3: styles.timelineLine} ${
                    index < activeIndex ? styles.visitedLine : styles.nonvisitedLine
                  }`} style={activeIndex === last_index? { width: `${(activeIndex ) * 25  }%` }: { width: `${(activeIndex ) * 25 +5 }%`  }}
                ></div>
                <div
                className={`${sliderscount ===3 ? styles.timelineLine3: styles.timelineLine} ${
                  index < activeIndex ? styles.visitedLine : ''
                }`} 
              ></div>
              </> 
            
            )}
          </React.Fragment>
        ))}
      </div>

  {/* Custom Next Arrow - Position outside Swiper */}
        {/* This button's class name needs to match the one in Swiper's navigation config */}
        { activeIndex === last_index ?   <button className={`${styles.navButtonNone} ${styles.navNext}`} ></button>: 
        <button className={`${styles.navButton} ${styles.navNext}`}>
           <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>



        }

{ activeIndex === 0 ?   <button className={`${styles.navButtonNone} ${styles.navPrev}`} ></button>: <button className={`${styles.navButton} ${styles.navPrev}`} >
         <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
  <polyline points="15 18 9 12 15 6"></polyline>
</svg>
           </button> }
      {/* Swiper Slider */}
      <div className={styles.swiperWrapper}>
         {/* Optional: Custom Left Arrow - Position outside Swiper */}
       

        <Swiper
          modules={[Navigation,Autoplay /*, Pagination */]}
          spaceBetween={30} // Adjust spacing between slides
         
          autoplay={{ delay: 3000, disableOnInteraction: true ,stopOnLastSlide:true}}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 1.75,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 1.65,
              spaceBetween: 20,
            },
            1400: {
              slidesPerView: 1.25,
              spaceBetween: 30,
            },
            1500: {
              slidesPerView: 1.20,
              spaceBetween: 30,
            },
            1600: {
              slidesPerView: 1.05,
              spaceBetween: 30,
            },
            1800: {
              slidesPerView: 0.8,
              spaceBetween: 30,
            },
          }}
          slidesPerView={1.2} // Show 1 full slide and parts of the next/prev
          centeredSlides={true} // Center the active slide
          navigation={{ // Use Swiper's built-in navigation (can be styled)
            nextEl: `.${styles.navNext}`, // CSS selector for next button
            prevEl: `.${styles.navPrev}`, // CSS selector for prev button (optional)
          }}
          // pagination={{ clickable: true }} // Optional pagination dots
          onSlideChange={handleSlideChange} // Update timeline on slide change
          className={styles.swiperContainer} // Custom class for the Swiper container
          // Allow touch control even if navigation buttons are outside
          allowTouchMove={true}
          loop={false}
       
        >
           <SwiperSlide key="zero"  className={
              // Combine base class with conditional class
              `${styles.slidezerobg}`
              // ^^^ If activeIndex is 3, add the 'finalSlideHighlight' class
              //     Otherwise, add nothing extra ('')
            }   >

            <div className={styles.slidezero}>
              <div>
                <svg width="400" height="330" viewBox="0 0 459 460" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100.361 105.038V93.4816L94.6726 75.8776H100.253L103.385 86.1376L106.301 75.8776H111.701L106.085 93.4816V105.038H100.361ZM121.802 105.434C119.666 105.434 117.974 105.05 116.726 104.282C115.478 103.514 114.578 102.422 114.026 101.006C113.498 99.5656 113.234 97.8496 113.234 95.8576V84.9856C113.234 82.9936 113.498 81.2896 114.026 79.8736C114.578 78.4576 115.478 77.3776 116.726 76.6336C117.974 75.8896 119.666 75.5176 121.802 75.5176C123.962 75.5176 125.666 75.9016 126.914 76.6696C128.186 77.4136 129.086 78.4936 129.614 79.9096C130.166 81.3016 130.442 82.9936 130.442 84.9856V95.8576C130.442 97.8496 130.166 99.5656 129.614 101.006C129.086 102.422 128.186 103.514 126.914 104.282C125.666 105.05 123.962 105.434 121.802 105.434ZM121.802 101.15C122.57 101.15 123.134 100.982 123.494 100.646C123.854 100.286 124.094 99.8176 124.214 99.2416C124.334 98.6416 124.394 98.0056 124.394 97.3336V83.5456C124.394 82.8736 124.334 82.2496 124.214 81.6736C124.094 81.0976 123.854 80.6416 123.494 80.3056C123.134 79.9456 122.57 79.7656 121.802 79.7656C121.082 79.7656 120.542 79.9456 120.182 80.3056C119.822 80.6416 119.582 81.0976 119.462 81.6736C119.342 82.2496 119.282 82.8736 119.282 83.5456V97.3336C119.282 98.0056 119.33 98.6416 119.426 99.2416C119.546 99.8176 119.786 100.286 120.146 100.646C120.506 100.982 121.058 101.15 121.802 101.15ZM142.616 105.434C140.408 105.434 138.692 105.062 137.468 104.318C136.244 103.55 135.38 102.458 134.876 101.042C134.396 99.6016 134.156 97.8616 134.156 95.8216V75.8776H140.024V96.6496C140.024 97.3696 140.072 98.0776 140.168 98.7736C140.288 99.4696 140.528 100.034 140.888 100.466C141.272 100.898 141.848 101.114 142.616 101.114C143.408 101.114 143.984 100.898 144.344 100.466C144.728 100.034 144.968 99.4696 145.064 98.7736C145.16 98.0776 145.208 97.3696 145.208 96.6496V75.8776H151.076V95.8216C151.076 97.8616 150.824 99.6016 150.32 101.042C149.84 102.458 148.988 103.55 147.764 104.318C146.54 105.062 144.824 105.434 142.616 105.434ZM162.78 105.038L168.432 75.8776H175.02L180.636 105.038H175.128L174.084 98.6296H169.476L168.36 105.038H162.78ZM170.016 94.9936H173.508L171.744 83.2216L170.016 94.9936ZM183.592 105.038V75.8776H191.152C193.12 75.8776 194.8 76.1056 196.192 76.5616C197.608 76.9936 198.688 77.7736 199.432 78.9016C200.2 80.0296 200.584 81.5896 200.584 83.5816C200.584 84.7816 200.476 85.8496 200.26 86.7856C200.068 87.6976 199.708 88.5016 199.18 89.1976C198.676 89.8696 197.956 90.4096 197.02 90.8176L201.052 105.038H194.968L191.62 91.8256H189.532V105.038H183.592ZM189.532 88.2976H191.26C192.22 88.2976 192.976 88.1416 193.528 87.8296C194.08 87.5176 194.464 87.0496 194.68 86.4256C194.92 85.7776 195.04 84.9856 195.04 84.0496C195.04 82.7056 194.788 81.6856 194.284 80.9896C193.804 80.2696 192.892 79.9096 191.548 79.9096H189.532V88.2976ZM204.58 105.038V75.8776H217.288V79.9816H210.52V87.7216H215.74V91.8616H210.52V101.006H217.36V105.038H204.58ZM229.437 105.038V75.8776H235.377V87.8656H240.525V75.8776H246.465V105.038H240.525V92.1136H235.377V105.038H229.437ZM250.951 105.038V75.8776H263.659V79.9816H256.891V87.7216H262.111V91.8616H256.891V101.006H263.731V105.038H250.951ZM266.736 105.038V75.8776H274.296C276.264 75.8776 277.944 76.1056 279.336 76.5616C280.752 76.9936 281.832 77.7736 282.576 78.9016C283.344 80.0296 283.728 81.5896 283.728 83.5816C283.728 84.7816 283.62 85.8496 283.404 86.7856C283.212 87.6976 282.852 88.5016 282.324 89.1976C281.82 89.8696 281.1 90.4096 280.164 90.8176L284.196 105.038H278.112L274.764 91.8256H272.676V105.038H266.736ZM272.676 88.2976H274.404C275.364 88.2976 276.12 88.1416 276.672 87.8296C277.224 87.5176 277.608 87.0496 277.824 86.4256C278.064 85.7776 278.184 84.9856 278.184 84.0496C278.184 82.7056 277.932 81.6856 277.428 80.9896C276.948 80.2696 276.036 79.9096 274.692 79.9096H272.676V88.2976ZM287.724 105.038V75.8776H300.432V79.9816H293.664V87.7216H298.884V91.8616H293.664V101.006H300.504V105.038H287.724Z" fill="#1A1A1A"/>
                  <path d="M186.655 128.937C183.805 188.847 207.463 303.422 324.886 282.442M324.886 282.442L312.613 297.317M324.886 282.442L308.2 266.338" stroke="#424242" strokeWidth="8.11678" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
           </SwiperSlide>
          {transformationData.map((item) => (
            <SwiperSlide key={item.id}  className={
              // Combine base class with conditional class
              `${styles.slide} ${activeIndex === last_index ? styles.finalSlideHighlight : ''} ${activeIndex === item.index ? styles.slideactive : styles.slidenoactive}`
              // ^^^ If activeIndex is 3, add the 'finalSlideHighlight' class
              //     Otherwise, add nothing extra ('')
            }  >
             { activeIndex ===  last_index  &&  item.index === last_index ? <Confetti>
              <Lottie loop={false} autoplay animationData={bwsconfetti}     />   
            
    
    </Confetti>  :'' }
              <div className={styles.slideContent}>
                <div className={styles.imageContainer}>
                   <img
                    src={item.imageUrl}
                    alt={`${item.timelineLabel} Transformation ${item.label_bodyfat_alt}`}
                    className={styles.slideImage}
                  />
                   <span className={styles.bodyFatLabel}>{item.labelbodyfat}  {activeIndex === last_index ? <> <svg width="36" height="36" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.02305 3.01953H13.9273C14.0882 3.01953 14.2267 3.01953 14.3518 3.03473C14.8003 3.09058 15.2168 3.29582 15.5343 3.61736C15.8518 3.9389 16.0517 4.358 16.1019 4.80707H16.8222C17.0117 4.80529 17.4273 4.80171 17.7705 5.03141C18.2147 5.32725 18.3488 5.83581 18.3488 6.37118C18.3488 8.8076 17.0501 10.4343 15.3922 11.3379C14.4671 13.0217 12.7583 14.1917 10.9752 14.1917C9.61754 14.1917 8.32962 13.457 7.40277 12.4408C7.09481 12.1048 6.82447 11.7362 6.59659 11.3414C4.93954 10.4423 3.60156 8.81743 3.60156 6.37118C3.60156 5.83491 3.73563 5.32725 4.17894 5.03141C4.52304 4.80171 4.93865 4.80529 5.12812 4.80707H5.8485L5.85119 4.78205C5.90645 4.33788 6.10831 3.92484 6.4248 3.60834C6.7413 3.29185 7.15434 3.08999 7.59851 3.03473C7.72364 3.01953 7.86217 3.01953 8.02305 3.01953ZM7.17665 5.4774V5.48008L7.16771 8.6056V8.6065C7.16771 9.25091 7.35183 9.90962 7.67091 10.5129L7.68342 10.5353C7.87558 10.8946 8.116 11.2324 8.39397 11.5363C9.14652 12.3621 10.0993 12.851 10.9761 12.851C12.247 12.851 13.5868 11.9322 14.283 10.5773C14.5993 9.96812 14.7648 9.29197 14.7657 8.6056L14.7639 8.60382L14.7746 5.24234C14.7746 5.02605 14.7728 4.97868 14.7692 4.9474C14.7507 4.79954 14.6835 4.66206 14.5781 4.55669C14.4727 4.45132 14.3353 4.38407 14.1874 4.36555C14.0892 4.35971 13.9908 4.35792 13.8925 4.36019H8.0588C7.84162 4.36019 7.79514 4.36108 7.76386 4.36555C7.616 4.38407 7.47852 4.45132 7.37315 4.55669C7.26778 4.66206 7.20053 4.79954 7.18201 4.9474C7.17617 5.0456 7.17438 5.14399 7.17665 5.24234V5.4774ZM16.1126 6.14773L16.1045 8.6056V8.6065M16.084 9.08824C16.6542 8.40182 17.009 7.50627 17.009 6.37118C17.009 6.26571 17.0001 6.196 16.9921 6.1522C16.9233 6.14806 16.8544 6.14657 16.7856 6.14773H16.1126M5.84493 9.0364C5.83145 8.8932 5.82488 8.74944 5.82527 8.6056V8.60382L5.83331 6.14773H5.16566C5.06824 6.14773 5.00657 6.14773 4.9592 6.1522C4.94664 6.22449 4.94095 6.29781 4.94222 6.37118C4.94222 7.47677 5.289 8.35535 5.84493 9.0364ZM10.9752 14.6386C11.153 14.6386 11.3235 14.7092 11.4492 14.8349C11.5749 14.9606 11.6455 15.1311 11.6455 15.3089V17.3199H14.5503C14.728 17.3199 14.8985 17.3905 15.0243 17.5162C15.15 17.6419 15.2206 17.8124 15.2206 17.9902C15.2206 18.168 15.15 18.3385 15.0243 18.4642C14.8985 18.5899 14.728 18.6605 14.5503 18.6605H7.40009C7.22231 18.6605 7.05181 18.5899 6.9261 18.4642C6.80039 18.3385 6.72976 18.168 6.72976 17.9902C6.72976 17.8124 6.80039 17.6419 6.9261 17.5162C7.05181 17.3905 7.22231 17.3199 7.40009 17.3199H10.3049V15.3089C10.3049 15.1311 10.3755 14.9606 10.5012 14.8349C10.6269 14.7092 10.7974 14.6386 10.9752 14.6386Z" fill="white"/>
<path d="M10.7697 5.97327C10.7868 5.93297 10.8155 5.8986 10.852 5.87444C10.8886 5.85028 10.9314 5.8374 10.9752 5.8374C11.019 5.8374 11.0619 5.85028 11.0984 5.87444C11.135 5.8986 11.1636 5.93297 11.1808 5.97327L11.6322 7.05653C11.6479 7.09433 11.6737 7.12708 11.7068 7.1512C11.7399 7.17531 11.779 7.18987 11.8198 7.19327L12.9898 7.28712C13.0338 7.2906 13.0758 7.30705 13.1105 7.33437C13.1451 7.3617 13.1709 7.39868 13.1846 7.44066C13.1983 7.48263 13.1992 7.52772 13.1873 7.57022C13.1754 7.61273 13.1511 7.65075 13.1176 7.67948L12.2265 8.44276C12.1954 8.46957 12.1722 8.50444 12.1596 8.54354C12.147 8.58265 12.1454 8.62447 12.155 8.66442L12.4267 9.80487C12.4372 9.84791 12.4346 9.89309 12.4194 9.93468C12.4041 9.97626 12.3769 10.0124 12.341 10.0384C12.3052 10.0645 12.2625 10.0793 12.2182 10.081C12.1739 10.0827 12.1302 10.0712 12.0924 10.048L11.0914 9.43664C11.0564 9.41533 11.0162 9.40405 10.9752 9.40405C10.9342 9.40405 10.894 9.41533 10.859 9.43664L9.85802 10.048C9.8203 10.0712 9.77653 10.0827 9.73227 10.081C9.68801 10.0793 9.64525 10.0645 9.60943 10.0384C9.5736 10.0124 9.54633 9.97626 9.53108 9.93468C9.51582 9.89309 9.51327 9.84791 9.52375 9.80487L9.79635 8.66442C9.80596 8.62447 9.80437 8.58265 9.79176 8.54354C9.77914 8.50444 9.75599 8.46957 9.72484 8.44276L8.83286 7.67948C8.79904 7.65081 8.77452 7.61273 8.76241 7.57008C8.75029 7.52743 8.75114 7.48215 8.76485 7.43998C8.77855 7.39782 8.80449 7.36068 8.83936 7.3333C8.87423 7.30592 8.91646 7.28953 8.96067 7.28622L10.1297 7.19327C10.1707 7.19003 10.21 7.17554 10.2432 7.15142C10.2765 7.12729 10.3025 7.09446 10.3183 7.05653L10.7697 5.97327Z" fill="white"/>
</svg>  </> 
 :''}</span>
                </div>

                <div className={styles.detailsContainer}>
                  <div className={styles.detailsContainerInnerDiv}>
                    <div>
                   </div>
                   </div>
                 {/* <div className={styles.progressBar}>
                     <div className={styles.progressInner} style={{ width: `${(activeIndex + 1) * 25}%` }}></div>
                   </div>
                   */}
                   <p className={styles.description}>{item.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      
      </div>
    </div>
  );
}

export default TransformationSliderDesktop;